import { ref } from "vue";
import { cloneDeep } from "@/shared/utils/helpers";

export function useBackupData<T extends Record<string, any>>(initialData: T) {
    const backupData = ref<T>(initialData);

    return {
        backupData,
        setBackupValue(value: T) {
            backupData.value = cloneDeep(value);
        },
    };
}
